// extracted by mini-css-extract-plugin
export default {"border":"AssetFormItem_border__2mgF+","header":"AssetFormItem_header__KsXXX","error":"AssetFormItem_error__XJDc3","input":"AssetFormItem_input__KbKOJ"};